"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAPI = void 0;
var React = __importStar(require("react"));
var react_1 = __importDefault(require("fast-deep-equal/react"));
var _1 = require(".");
function useAPI(apiCall, args) {
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    var _b = React.useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = React.useState(undefined), error = _c[0], setError = _c[1];
    var forceUpdate = _1.useForceUpdate();
    var argsRef = React.useRef(args);
    if (!react_1.default(argsRef.current, args)) {
        argsRef.current = args;
    }
    React.useEffect(function () {
        setIsLoading(true);
        apiCall(argsRef.current)
            .then(setData)
            .catch(setError)
            .finally(function () { return setIsLoading(false); });
    }, [setData, setIsLoading, setError, argsRef.current]);
    return {
        data: data,
        isLoading: isLoading,
        error: error,
        refresh: function () {
            argsRef.current = args;
            forceUpdate();
        },
    };
}
exports.useAPI = useAPI;
//# sourceMappingURL=useAPI.js.map